import React from "react";
import { Card } from "components/ui/card";
import { Skeleton } from "components/ui/skeleton";

const CardSkeleton: React.FC = () => (
    <Card variant="catalog" className="pointer-events-none">
        <div className="flex items-start gap-3">
            <Skeleton className="h-14 w-14 shrink-0 rounded-2xl" />
            <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-3 w-16" />
            </div>
        </div>
        <div className="space-y-2">
            <Skeleton className="h-3 w-24" />
            <div className="flex gap-1.5">
                <Skeleton className="h-6 w-20 rounded-lg" />
                <Skeleton className="h-6 w-16 rounded-lg" />
            </div>
        </div>
        <div className="flex-1 space-y-1.5">
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-4/5" />
            <Skeleton className="h-3 w-3/5" />
        </div>
        <div className="flex items-center justify-between">
            <div className="space-y-1">
                <Skeleton className="h-2 w-12" />
                <Skeleton className="h-6 w-16" />
            </div>
            <Skeleton className="h-10 w-28 rounded-xl" />
        </div>
    </Card>
);

export default CardSkeleton;
